import { render, staticRenderFns } from "./formCard.vue?vue&type=template&id=4c42024a&scoped=true"
import script from "./formCard.vue?vue&type=script&lang=js"
export * from "./formCard.vue?vue&type=script&lang=js"
import style0 from "./formCard.vue?vue&type=style&index=0&id=4c42024a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c42024a",
  null
  
)

export default component.exports